function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M16.737 7.484V4.008c-1.013-1.355-2.71-2.152-4.608-2.152-1.899 0-3.594.797-4.608 2.152v3.476h9.07v3.683h1.838V7.484h-1.692zm5.426 0v.92c0 3.591.441 5.783.9 8.103.46 2.302.937 4.696.937 8.47v6.507H0v-6.507c0-3.774.478-6.168.937-8.47.459-2.32.9-4.512.9-8.102v-.921H5.57v3.683h1.837V7.484h-1.73V3.433C5.861 3.266 7.52 0 12.128 0s6.267 3.266 6.452 3.433v4.05h3.582z"
});

function SvgCartIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32
  }, props), _ref);
}

export default SvgCartIcon;